var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Dialog from "./Dialog";
import Button from "../../elements/button/Button";
import ButtonBar from "../../elements/button/ButtonBar";
export const ConfirmDialogFooter = (props) => (React.createElement(ButtonBar, null,
    React.createElement(Button, { cta: true, onClick: () => props.onConfirm(), pending: props.confirmPending, disabled: props.confirmPending || props.disableConfirmButton }, props.confirmLabel),
    React.createElement(Button, { onClick: () => props.onRequestClose(), disabled: props.confirmPending }, props.cancelLabel)));
class ConfirmDialog extends React.Component {
    render() {
        const _a = this.props, { onConfirm, confirmPending, confirmLabel, cancelLabel, children } = _a, restProps = __rest(_a, ["onConfirm", "confirmPending", "confirmLabel", "cancelLabel", "children"]);
        return (React.createElement(Dialog, Object.assign({}, restProps, { showCloseButton: false, isCloseable: !this.props.confirmPending, showAboveDialog: true, shouldCloseOnOverlayClick: false, footer: React.createElement(ConfirmDialogFooter, Object.assign({}, this.props)) }), this.props.children));
    }
}
ConfirmDialog.defaultProps = {
    confirmLabel: "Ok",
    cancelLabel: "Avbryt",
    style: "small",
    confirmPending: false
};
export default ConfirmDialog;
//# sourceMappingURL=ConfirmDialog.js.map